<template>
  <div ref="htmlContainer" class="map-container">
    <div ref="viewport" class="viewport">
      <div
        ref="mapContent"
        class="map-content"
        v-html="MapSVG"
      />
    </div>
    <button
      v-if="buttons.left"
      class="rc-btn rc-btn__map rc-btn__map-left"
      @click.prevent.stop="handleMapMove(100, 0)"
    />
    <button
      v-if="buttons.right"
      class="rc-btn rc-btn__map rc-btn__map-right"
      @click.prevent.stop="handleMapMove(-100, 0)"
    />
    <button
      v-if="buttons.up"
      class="rc-btn rc-btn__map rc-btn__map-up"
      @click.prevent.stop="handleMapMove(0, 100)"
    />
    <button
      v-if="buttons.bottom"
      class="rc-btn rc-btn__map rc-btn__map-bottom"
      @click.prevent.stop="handleMapMove(0, -100)"
    />
    <button
      class="rc-btn rc-btn__map rc-btn__map-zoom-plus"
      @click="handleMapZoom(0.2)"
    >+</button>
    <button
      class="rc-btn rc-btn__map rc-btn__map-zoom-minus"
      @click="handleMapZoom(-0.2)"
    >-</button>
  </div>
</template>

<script>
export default {
  name: 'MapItemView',

  props: {
    map: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    standList: {
      type: Array,
      default: () => [],
    },
    standInfo: {
      type: Object,
      default: null,
    },
    startStandId: {
      type: String,
      default: null,
    },
  },

  emits: ['click-stand'],

  data() {
    return {
      stands: new Map(),
      vpWidth: 0,
      vpHeight: 0,
      isDragging: false,
      originWidth: null,
      originHeight: null,
      startX: 0,
      startX_2: 0,
      startY: 0,
      startY_2: 0,
      offsetX: 0,
      offsetY: 0,
      shiftX: 0,
      shiftY: 0,
      scale: 1.0,
      isExistActive: false,

      buttons: {
        left: false,
        right: false,
        bottom: false,
        up: false,
      },
    };
  },

  computed: {
    MapSVG() {
      return this.map?.svg_map ?? '';
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.initMap();
    });
  },

  beforeUnmount() {
    this.removeListeners();
  },

  methods: {
    // ─── Инициализация ───────────────────────────────────────
    initMap() {
      const { viewport } = this.$refs;
      const { mapContent } = this.$refs;
      if (!viewport || !mapContent) return;

      // const standIds = this.standList
      // .map((s) => (typeof s === 'string' ? s : s.id ?? s.num_stand ?? ''));

      // Привязка кликов к стендам
      mapContent.querySelectorAll('g.stand').forEach((stand) => {
        const numStand = stand.id;
        // if (standIds.includes(numStand)) {
        stand.classList.remove('stand-empty');
        this.stands.set(numStand, stand);

        stand.addEventListener('click', () => {
          if (this.isDragging) return;
          if (!stand.classList.contains('active')) {
            this.highlightStand(stand.id);
            console.log(stand);
            this.$emit('click-stand', stand.id);
          }
        });
        // }
      });

      // Вычисление начальных размеров
      const svgEl = mapContent.children[0];
      if (svgEl) {
        this.originWidth = svgEl.clientWidth;
        this.originHeight = svgEl.clientHeight;
      }

      this.offsetX = (viewport.offsetWidth - mapContent.offsetWidth * this.scale) / 2;
      this.offsetY = (viewport.offsetHeight - mapContent.offsetHeight * this.scale) / 2;
      this.shiftX = (this.originWidth - this.originWidth * this.scale) / 2;
      this.shiftY = (this.originHeight - this.originHeight * this.scale) / 2;

      const vpRect = viewport.getBoundingClientRect();
      this.vpWidth = vpRect.width;
      this.vpHeight = vpRect.height;

      // Слушатели
      this.addListeners();
      this.updateTransform();

      // Автопоказ стенда
      if (this.startStandId) {
        setTimeout(() => {
          this.showStand(this.startStandId);
        }, 550);
      }
    },

    addListeners() {
      const vp = this.$refs.viewport;
      if (!vp) return;

      vp.addEventListener('mousedown', this.handleMouseDown);
      vp.addEventListener('mousemove', this.handleMouseMove);
      vp.addEventListener('mouseup', this.handleMouseUp);
      vp.addEventListener('wheel', this.handleWheel, { passive: false });

      vp.addEventListener('touchstart', this.handleTouchStart);
      vp.addEventListener('touchmove', this.handleTouchMove);
      vp.addEventListener('touchend', this.handleTouchEnd);
    },

    removeListeners() {
      const vp = this.$refs.viewport;
      if (!vp) return;

      vp.removeEventListener('mousedown', this.handleMouseDown);
      vp.removeEventListener('mousemove', this.handleMouseMove);
      vp.removeEventListener('mouseup', this.handleMouseUp);
      vp.removeEventListener('wheel', this.handleWheel);

      vp.removeEventListener('touchstart', this.handleTouchStart);
      vp.removeEventListener('touchmove', this.handleTouchMove);
      vp.removeEventListener('touchend', this.handleTouchEnd);
    },

    // ─── Touch ───────────────────────────────────────────────
    handleTouchStart(e) {
      if (e.touches[0]) {
        this.isDragging = true;
        this.startX = e.touches[0].clientX - this.offsetX;
        this.startY = e.touches[0].clientY - this.offsetY;
      }
      if (e.touches[1]) {
        e.preventDefault();
        this.isDragging = false;
        this.startX_2 = e.touches[1].clientX - this.offsetX;
        this.startY_2 = e.touches[1].clientY - this.offsetY;
      }
    },

    handleTouchMove(e) {
      e.stopPropagation();
      e.preventDefault();

      if (e.touches.length === 1) {
        if (!this.isDragging) return;
        this.offsetX = e.touches[0].clientX - this.startX;
        this.offsetY = e.touches[0].clientY - this.startY;
        this.updateTransform();
      }
      if (e.touches.length === 2) {
        this.pinchZoom(e.touches[0], e.touches[1]);
      }
    },

    handleTouchEnd() {
      this.isDragging = false;
    },

    pinchZoom(touch1, touch2) {
      const initialDistance = this.calculateDistance(
        { x: this.startX, y: this.startY },
        { x: this.startX_2, y: this.startY_2 },
      );
      const currentDistance = this.calculateDistance(
        {
          x: touch1.clientX - this.offsetX,
          y: touch1.clientY - this.offsetY,
        },
        {
          x: touch2.clientX - this.offsetX,
          y: touch2.clientY - this.offsetY,
        },
      );
      const diff = Math.round(initialDistance) - Math.round(currentDistance);

      if (diff !== 0 && Math.round(diff) % 10 === 0) {
        this.startX = touch1.clientX - this.offsetX;
        this.startY = touch1.clientY - this.offsetY;
        this.startX_2 = touch2.clientX - this.offsetX;
        this.startY_2 = touch2.clientY - this.offsetY;

        const scaleStep = diff > 0 ? -0.2 : 0.2;
        this.scale = Math.min(Math.max(0.3, this.scale + scaleStep), 10);
        this.updateTransform();
      }
    },

    calculateDistance(p1, p2) {
      const dx = p2.x - p1.x;
      const dy = p2.y - p1.y;
      return Math.sqrt(dx * dx + dy * dy);
    },

    // ─── Mouse ───────────────────────────────────────────────
    handleMouseDown(e) {
      e.preventDefault();
      this.isDragging = true;
      this.startX = e.clientX - this.offsetX;
      this.startY = e.clientY - this.offsetY;
      this.$refs.viewport.style.cursor = 'grabbing';
      this.$refs.mapContent.classList.add('handle-drag');
    },

    handleMouseMove(e) {
      e.stopPropagation();
      e.preventDefault();
      if (!this.isDragging) return;

      this.offsetX = e.clientX - this.startX;
      this.offsetY = e.clientY - this.startY;
      this.updateTransform();
    },

    handleMouseUp() {
      this.isDragging = false;
      if (this.$refs.viewport) {
        this.$refs.viewport.style.cursor = 'grab';
      }
      if (this.$refs.mapContent) {
        this.$refs.mapContent.classList.remove('handle-drag');
      }
    },

    // ─── Управление картой ───────────────────────────────────
    handleMapMove(x, y) {
      this.offsetX += x;
      this.offsetY += y;
      this.updateTransform();
    },

    handleMapZoom(scaleDelta) {
      this.scale = Math.min(Math.max(0.3, this.scale + scaleDelta), 10);
      this.updateTransform();
    },

    handleWheel(e) {
      e.preventDefault();

      const delta = -e.deltaY;
      const zoomIntensity = 0.1;
      const oldScale = this.scale;

      this.scale = Math.min(
        Math.max(0.1, this.scale + delta * zoomIntensity * 0.01),
        10,
      );

      // Не позволяем уменьшить карту слишком сильно
      if (this.originWidth * this.scale * 4 < this.vpWidth) {
        this.scale = oldScale;
      }

      const bound = this.$refs.mapContent.getBoundingClientRect();
      const mouseX = e.clientX - bound.left;
      const mouseY = e.clientY - bound.top;

      const scaleRelative = this.scale / oldScale;

      this.shiftX = (this.originWidth - this.originWidth * this.scale) / 2;
      this.shiftY = (this.originHeight - this.originHeight * this.scale) / 2;

      // Корректируем offset для зума относительно курсора
      this.offsetX += mouseX - mouseX * scaleRelative;
      this.offsetY += mouseY - mouseY * scaleRelative;

      this.updateTransform();
    },

    // ─── Transform и ограничения ─────────────────────────────
    checkOffset() {
      const contentBound = this.$refs.mapContent.getBoundingClientRect();

      const maxLeft = (this.vpWidth - contentBound.width) / 2 - contentBound.width / 2;
      const maxRight = (this.vpWidth - contentBound.width) / 2 + contentBound.width / 2;

      const maxTop = (this.vpHeight - contentBound.height) / 2 - contentBound.height / 2;
      const maxBottom = (this.vpHeight - contentBound.height) / 2 + contentBound.height / 2;

      this.offsetX = Math.max(Math.min(this.offsetX, maxRight), maxLeft);
      this.offsetY = Math.max(Math.min(this.offsetY, maxBottom), maxTop);
    },

    updateTransform() {
      this.checkOffset();
      const mc = this.$refs.mapContent;
      if (!mc) return;
      mc.style.transform = `translate(${this.offsetX - this.shiftX}px, ${
        this.offsetY - this.shiftY
      }px) scale(${this.scale})`;
    },

    // ─── Подсветка стендов ────────────────────────────────────
    clearHighlight() {
      console.log(this.isExistActive);
      if (this.isExistActive) {
        const mc = this.$refs.mapContent;
        if (!mc) return;
        mc.querySelectorAll('g.stand').forEach((stand) => {
          stand.classList.remove('active', 'no-active', 'animation');
        });
      }
      this.isExistActive = false;
    },

    highlightStand(standId, noactive = false) {
      const mc = this.$refs.mapContent;
      if (!mc) return null;

      let targetStand = null;

      mc.querySelectorAll('g.stand').forEach((stand) => {
        stand.classList.remove('active', 'no-active', 'animation');
        if (noactive) {
          stand.classList.add('no-active');
        }
        if (stand.id === standId) {
          targetStand = stand;
          this.isExistActive = true;
          setTimeout(() => {
            stand.classList.remove('no-active');
            stand.classList.add('active', 'animation');
          }, 600);
        }
      });

      return targetStand;
    },

    emptyStand(standId) {
      const mc = this.$refs.mapContent;
      if (mc) {
        mc.querySelectorAll('g.stand').forEach((stand) => {
          stand.classList.remove('active', 'no-active', 'animation');
          if (stand.id === standId) {
            this.isExistActive = true;
            stand.classList.add('stand-empty');
          }
        });
      }
    },

    showStand(standId) {
      // console.log('showStand', standId);
      const stand = this.highlightStand(`stand-${standId}`, true);
      if (!stand) return;

      const vpRect = this.$refs.viewport.getBoundingClientRect();
      const mcRect = this.$refs.mapContent.getBoundingClientRect();
      const standRect = stand.getBoundingClientRect();

      const viewportCenterX = vpRect.width / 2;
      const viewportCenterY = vpRect.height / 2;

      const standCenterX = standRect.left - mcRect.left + standRect.width / 2;
      const standCenterY = standRect.top - mcRect.top + standRect.height / 2;

      this.offsetX = viewportCenterX - standCenterX;
      this.offsetY = viewportCenterY - standCenterY;

      this.updateTransform();
    },
  },
};
</script>

<style lang="scss" scoped>
.map-container {
  position: relative;
  grid-column: start / end;
  grid-row: start / end;
  // background-color: #f0f0f0;

  .viewport {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    cursor: default;
  }

  .map-content {
    position: absolute;
    width: 100%;
    transition: transform 0.5s ease-out; /* Плавное перемещение */
    // will-change: transform; /* Оптимизация для анимаций */

    &.handle-drag {
      transition: transform 0.1s ease-out;
    }

    & > * {
      display: block;
      // max-width: 100%;
      // max-height: 100%;
    }
    & > svg {
      pointer-events: auto;
    }
  }
}
.rc-btn {
  &__map {
    position: absolute;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 2px solid #e62d86;
    background-color: #ffffff;
    color: #e62d86;
    font-size: 24px;
    line-height: 1em;
    font-weight: 700;
  }

  &__map-zoom-plus {
    bottom: 168px;
    right: 10px;
  }
  &__map-zoom-minus {
    bottom: 122px;
    right: 10px;
  }
}
</style>
